"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _underscore = _interopRequireDefault(require("underscore"));
var _source = require("../../../actions/source");
var _actionUtils = require("../../../utils/actionUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function attendeeRosterChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector,
    attendeeRoster = _ref2.attendeeRoster;
  var state = getState();
  var localAttendeeRoster = state.attendeeRoster;
  if (notifyingDirector && !(0, _actionUtils.isSameAttendee)(notifyingDirector, state)) {
    if (!_underscore["default"].isEqual(attendeeRoster, localAttendeeRoster)) {
      dispatch((0, _source.getSources)());
    }
  }
}
var _default = exports["default"] = attendeeRosterChanged;